module.exports = __webpack_public_path__ + "img/logo-training.495c2ef1.svg";